"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conversation = void 0;
const index_1 = require("../../index");
class Conversation extends index_1.Base {
    user_id = '';
    type = '';
    subtype = '';
    title = '';
    history = [];
    metadata = {};
    status;
    provider = '';
    result = '';
    currentResponse = '';
    error = '';
    generationStartMs;
    generationCompleteMs;
    errorMs;
    usage = {};
    turn_count = 0;
    _m = ['id', 'type', 'subtype', 'user_id', 'title', 'status', 'provider'];
    _s = ['id', 'type', 'subtype', 'user_id', 'title', 'turn_count', 'last_date', 'status', 'provider'];
    constructor(data, olMap) {
        super('conversations', 20);
        (0, index_1.setObjectProperties)(this, data, olMap, Conversation);
    }
    toString() {
        return this.title || `${this.type} Conversation`;
    }
    addTurn(turn) {
        if (!this.history)
            this.history = [];
        this.history.push({ ...turn, timestamp: Date.now() });
        this.turn_count = this.history.length;
        this.last_date = Date.now();
    }
    getHistory(limit = 20) {
        return (this.history ?? []).slice(-limit);
    }
    toMessages(limit = 6, assistantRole = 'assistant') {
        return this.getHistory(limit).map(turn => ({
            role: (turn.role === 'assistant' ? assistantRole : 'user'),
            content: turn.parts.map(p => p.text ? { text: p.text } : p).filter(Boolean),
        }));
    }
    accumulateUsage(incoming) {
        const u = this.usage ?? {};
        this.usage = {
            ...incoming,
            totalInputTokens: (u.totalInputTokens ?? 0) + (incoming.inputTokens ?? 0),
            totalOutputTokens: (u.totalOutputTokens ?? 0) + (incoming.outputTokens ?? 0),
            totalDurationMs: (u.totalDurationMs ?? 0) + (incoming.durationMs ?? 0),
            generationCount: (u.generationCount ?? 0) + 1,
        };
    }
    clearHistory() {
        this.history = [];
        this.turn_count = 0;
    }
    toJSON() {
        const r = super.toJSON();
        r.last_date = this.last_date || this.date;
        return r;
    }
}
exports.Conversation = Conversation;
index_1.olm.conversations = (ref, map) => {
    return new Conversation(ref, map);
};
